import moment, { Moment } from 'moment'

/**
 * Parses a raw date input string (DD/MM/YYYY or YYYY-MM-DD) into a Moment object.
 * Supports both DD/MM/YYYY and YYYY-MM-DD formats with `/` or `-` separators.
 * If the day exceeds the number of days in the given month, it adjusts to the last
 * valid day of that month (e.g. 31/04/2026 → 30/04/2026, 31/02/2026 → 28/02/2026).
 *
 * @returns A Moment object if the input matches a known format, or null otherwise.
 */
export function parseAndNormalizeDate(rawInput: string): Moment | null {
  let day = 0
  let month = 0
  let year = 0

  const dmy = rawInput.match(/^(\d{1,2})[/\-](\d{1,2})[/\-](\d{4})/)
  const ymd = rawInput.match(/^(\d{4})[/\-](\d{1,2})[/\-](\d{1,2})/)

  if (dmy) {
    day = parseInt(dmy[1])
    month = parseInt(dmy[2]) - 1
    year = parseInt(dmy[3])
  } else if (ymd) {
    year = parseInt(ymd[1])
    month = parseInt(ymd[2]) - 1
    day = parseInt(ymd[3])
  } else {
    return null
  }

  const daysInMonth = moment({ year, month }).daysInMonth()
  if (day > daysInMonth) {
    // Invalid day: adjust to the last valid day of the month
    return moment({ year, month, day: daysInMonth })
  }

  return moment({ year, month, day })
}
